import { Store } from 'utils';
import moment from 'moment/src/moment';

class Campaigns extends Store {

	getInitialState() {
		return {
			campaigns: [],
			filter: '',
			selected: null,
			active: false
		}
	}

	onSelectedCampaignChanged(state, data) {
		state.selected = data.campaign;
	}

	onRenamingCampaign(state, data) {

		var { campaign, name } = data;

		state.campaigns = state.campaigns.map(function(item) {
			if(item.id == campaign.id) {
				item = Object.assign({}, item);
				item.loading = true;
				item.title = name;
			}

			return item;
		});
	}

	onDeletingCampaign(state, data) {
		var { campaign } = data;

		state.campaigns = state.campaigns.map(function(item) {
			if(item.id == campaign.id) {
				item = Object.assign({}, item);
				item.loading = true;
			}

			return item;
		});
	}

	onCampaignDeleted(state, data) {
		var { id } = data;

		state.campaigns = state.campaigns.filter(function(item) {
			return item.id != id;
		});
	}

	onCampaignRenamed(state, data) {
		var { id } = data;

		state.campaigns = state.campaigns.map(function(item) {

			if(item.id == id) {
				item = Object.assign({}, item);
				item.loading = false;
			}

			return item;
		});
	}

	onAddCampaign(state, data) {
		state.campaigns = [{
			title: data.name,
			requestId: data.requestId,
			created: moment().format('DD.MM.YYYY'),
			type: 'db',
			id: null,
			loading: true,
			applications: 0
		}].concat(state.campaigns);
	}

	onAdsChanged(state, data) {
		state.campaigns = data.ads;
		state.active = data.active;
	}

	onCampaignSaved(state, data) {
		state.campaigns = state.campaigns.map(function(item) {
			if(item.requestId === data.requestId) {
				item = Object.assign({}, item);
				item.loading = false;
				item.id = data.id;
			}

			return item;
		});
	}

	onFolderFilterChanged(state, data) {
		state.filter = data.filter;
		state.selected = null;
	}

	onCampaignSelected(state, data) {
		state.selected = data.campaign;
	}

	onMoveInProgress(state, data) {
		state.selected = null;
	}
}

const store = new Campaigns();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/Campaigns.js